var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHalfScreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icHalfScreen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Fullscreen-Interface",
    transform: "translate(-900.000000, -1150.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(16.000000, 192.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(638.000000, 853.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(0.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fullscreen",
    transform: "translate(232.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.000000, 14.000000)",
    id: "icHalfScreen"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.78947368 L5.78947368,5.78947368 L5.78947368,0 L8.10526316,0 L8.10526316,8.10526316 L0,8.10526316 L0,5.78947368 Z M22,5.78947368 L22,8.10526316 L13.8947368,8.10526316 L13.8947368,0 L16.2105263,0 L16.2105263,5.78947368 L22,5.78947368 Z M0,16.2105263 L0,13.8947368 L8.10526316,13.8947368 L8.10526316,22 L5.78947368,22 L5.78947368,16.2105263 L0,16.2105263 Z M22,16.2105263 L16.2105263,16.2105263 L16.2105263,22 L13.8947368,22 L13.8947368,13.8947368 L22,13.8947368 L22,16.2105263 Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHalfScreen);
export default __webpack_public_path__ + "static/media/icHalfScreen.2650a5d55f5e082dfd002c3336fbbc48.svg";
export { ForwardRef as ReactComponent };